import React, { useMemo } from "react";
import SystemHealthCard from "./components/SystemHealthCard";
import ErrorCard from "./components/ErrorCard";
import { useSelector } from "react-redux";
import { getDir } from "orion-components/i18n/Config/selector";
import { getScrollBarAppState } from "orion-components/AppState/Global/selectors";
import ClientConnection from "./components/ClientConnection";
import { systemHealthSelector } from "./selectors";

const hasOwn = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);

const hasError = (errorFlag, health) => {
	if (errorFlag) {
		return true;
	} else if (hasOwn(health, "success") && !health.success) {
		return true;
	} else {
		return false;
	}
};

const SystemHealth = () => {
	const locale = useSelector(state => state.i18n.locale);
	const systemHealth = useSelector(systemHealthSelector);
	const error = useSelector(state => hasError(state.systemHealth.hasApiError, state.systemHealth.health));
	const dir = useSelector(state => getDir(state));
	const scrollBarsEnabled = useSelector(state => getScrollBarAppState(state));

	const styles = useMemo(
		() => ({
			container: {
				display: "flex",
				flexDirection: "column",
				height: "calc(100% - 48px)",
				...(!scrollBarsEnabled && { margin: "auto" }),
				...(scrollBarsEnabled && { marginLeft: "auto" })
			},
			healthChecksContainer: {
				overflowY: "scroll",
				marginLeft: 13,
				...(!scrollBarsEnabled && { marginRight: 13 })
			}
		}),
		[dir, scrollBarsEnabled]
	);

	return (
		<div style={styles.container}>
			<ClientConnection />
			<div style={styles.healthChecksContainer}>
				{!error ? (
					Object.keys(systemHealth).map(key => {
						const health = systemHealth[key];
						return (
							<SystemHealthCard
								key={key}
								title={health.label}
								hasError={health.error}
								healthSystems={health.systems}
								dir={dir}
								locale={locale}
							/>
						);
					})
				) : (
					<ErrorCard dir={dir} />
				)}
			</div>
		</div>
	);
};

export default SystemHealth;
